module.exports = __webpack_public_path__ + "assets/img/a.all_icon.4de4c66c.svg";